import { Route } from 'react-router-dom';
import WhatsApp from './WhatsApp';
import ListarMensajesComponente from './Listar-mensajes';
import ListarMensajesCobroComponente from './Listar-mensajes-cobro';
import ListarPreguntasComponente from './Listar-preguntas';
import CrearPreguntaComponent from './Crear-pregunta';

const WhatsAppRouter = (
  <Route path="whatsapp" element={<WhatsApp />}>
    <Route path="" element={<ListarMensajesComponente />} />
    <Route path="costo" element={<ListarMensajesCobroComponente />} />
    <Route path="preguntas" element={<ListarPreguntasComponente />} />
    <Route path="preguntas/crear" element={<CrearPreguntaComponent />} />
  </Route>
);

export default WhatsAppRouter;
